import Component from '../Component';
import { PIXIScrollBox } from 'Prototype/UI/PIXIScrollBox';
import { ScrollBox } from 'Prototype/ScrollBox';

export class ScrollBoxComponent extends Component<
    PIXIScrollBox,
    ScrollBox
> {
}
